import { render, staticRenderFns } from "./oldDailyBill.vue?vue&type=template&id=6595ccf8&scoped=true&"
import script from "./oldDailyBill.vue?vue&type=script&lang=js&"
export * from "./oldDailyBill.vue?vue&type=script&lang=js&"
import style0 from "./oldDailyBill.vue?vue&type=style&index=0&id=6595ccf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6595ccf8",
  null
  
)

export default component.exports